import MenuButton from './menu-button.element.js';

export default MenuButton;

MenuButton.define('wje-menu-button', MenuButton);
